import useDefaultTrebbleAntDTokenConfig from "../../../../../helper/useDefaultTrebbleAntDTokenConfig";

export const PositionSelector = ({ selectedPosition, setSelectedPosition }: { selectedPosition: string, setSelectedPosition: (position: string) => void }) => {
  const token = useDefaultTrebbleAntDTokenConfig();

  // Inline styles
  const styles = {
    container: {
      textAlign: "center",
      color: token.token.colorText,
      fontFamily: "Arial, sans-serif",
    },
    label: {
      fontSize: "20px",
      marginBottom: "10px",
    },
    grid: {
      display: "grid",
      gridTemplateColumns: "repeat(3, 20px)",
      gridTemplateRows: "repeat(3, 20px)",
      gap: "4px",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: token.token.colorBgElevated,
      padding: "4px",
      width: "68px",
      height: "68px",
      margin: "auto"
    },
    cellContainer: {
      width: "20px",
      height: "20px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    cell: {
      width: "4px",
      height: "4px",
      border: `1px solid ${token.token.colorText}`,
      borderRadius: "50%",
      backgroundColor: token.token.colorText,
      cursor: "pointer",
      transition: "all 0.3s ease",
    },
    "cell:hover": {
      width: "10px",
      height: "10px",
      backgroundColor: token.token.colorText,
      border: `1px solid ${token.token.colorPrimary}`,
    },
    activeCell: {
      width: "10px",
      height: "10px",
      backgroundColor: token.token.colorPrimary,
      border: `1px solid ${token.token.colorPrimary}`,
    },
  };

  return (
    <div style={styles.grid}>
      {[
        "top left",
        "top center",
        "top right",
        "center left",
        "center center",
        "center right",
        "bottom left",
        "bottom center",
        "bottom right",
      ].map((position) => (
        <div key={position} style={styles.cellContainer}>
          <div
            className={selectedPosition !== position ? "opacity-50" : ""}
            style={{
              ...styles.cell,
              ...(selectedPosition === position ? styles.activeCell : {}),
            }}
            onClick={() => setSelectedPosition(position)}
            onMouseEnter={(e) => {
              if (selectedPosition !== position) {
                (e.target as any).style.width = "10px";
                (e.target as any).style.height = "10px";
                (e.target as any).style.backgroundColor = token.token.colorText;
                (e.target as any).style.border = `1px solid ${token.token.colorPrimary}`;
              }
            }}
            onMouseLeave={(e) => {
              if (selectedPosition !== position) {
                (e.target as any).style.width = "4px";
                (e.target as any).style.height = "4px";
                (e.target as any).style.backgroundColor = token.token.colorText;
                (e.target as any).style.border = `1px solid ${token.token.colorText}`;
              }
            }}
          ></div>
        </div>
      ))}
    </div>
  );
};